const Checkbox = ({ name, label, checked, click, disabled = false }) => {
  return (
    <div>
      <label style={{ display: "flex", alignItems: "center" }}>
        <input
          type="checkbox"
          defaultChecked={checked}
          onClick={(e) => click(name, e.target.checked)}
          name={name}
          disabled={disabled}
        />{" "}
        <span className={disabled ? "disabled" : ""}>{label}</span>
      </label>
    </div>
  );
};

export default Checkbox;
